import React from "react";
import { ThemeContext } from "../contexts/ThemeContext";
import { DARK_BLUE, PRIMARY_BLUE } from "../enums/Colors";

export default function usePrimaryColor() {
  const { mode } = React.useContext(ThemeContext);
  return mode == "dark" ? PRIMARY_BLUE : DARK_BLUE;
}
